/*
	Release environment can be one of the following
	1. production - live environment
	2. beta - beta testing environment
	3. development - development environment
	4. local - local IP based environment
*/
const RELEASE_ENVIROMENT = "development";

/* ========================TEST URLs=============================== */
// const PRODUCTION_BASE_URL = "";
// const BETA_BASE_URL = "";
// const LOCAL_BASE_URL = "";
export const DEVELOPMENT_BASE_URL = "https://api.fhzq.peizi.hkcorp.vip";
export const ALT_URL_1 = "https://api1.fhzq.peizi.hkcorp.vip";
export const ALT_URL_2 = "https://api2.fhzq.peizi.hkcorp.vip";

/* ========================LIVE UNI=============================== */
// const PRODUCTION_BASE_URL = "";
// const BETA_BASE_URL = "";
// const LOCAL_BASE_URL = "";
// export const DEVELOPMENT_BASE_URL = "https://113.207.49.239:5221";
// export const ALT_URL_1 = "https://fhusa.fhzqyapi.com:5221";
// export const ALT_URL_2 = "https://qzrb2.fhzqpc.com:5221";

/* ========================BOOKMARK URLs=============================== */
const PRODUCTION_BASE_URL = "";
const BETA_BASE_URL = "";
const LOCAL_BASE_URL = "";
// export const DEVELOPMENT_BASE_URL = "https://113.207.49.239:5221";
// export const ALT_URL_1 = "https://fhusabkm.fhzqyapi.com:5221";
// export const ALT_URL_2 = "https://qzrb2.fhzqpc.com:5221";

/* ========================LIVE APK URLs=============================== */
// const PRODUCTION_BASE_URL = "";
// const BETA_BASE_URL = "";
// const LOCAL_BASE_URL = "";
// export const DEVELOPMENT_BASE_URL = "https://113.207.49.157:5222";
// export const ALT_URL_1 = "https://fhusa.fhzqyapi.com:5221";
// export const ALT_URL_2 = "https://qzrb1.fhzqapk.com:5221";

//test line change keys
export const backupAPISettings = {
	backupAPI: "https://hk99222.hk9999z.com/",
	name: "fhzq_test",
	token: "8f9cdc3be549b9ca"
}

export const BACKUP_API = backupAPISettings.backupAPI;

//live line change keys
// export const backupAPISettings = {
// 	backupAPI: "https://ndknfkdfnkdsmndkekekqw.sdsfhdshfdhbsjldblfdklaskldd232kj.com",
// 	name: "tOz0h3m894bm",
// 	token: "8f9cdc3be549b9ca"
// }

export {
	// CHAT_BASE_URL,
	// CRM_TOKEN,
	// CRM_SOCKET_BASE,
	RELEASE_ENVIROMENT,
};

export function getSystemBaseURL() {
	switch (RELEASE_ENVIROMENT) {
		case "production":
			return PRODUCTION_BASE_URL;
			break;
		case "beta":
			return BETA_BASE_URL;
			break;
		case "development":
			return DEVELOPMENT_BASE_URL;
			break;
		case "local":
			return LOCAL_BASE_URL;
			break;
		default:
			break;
	}
}

export function getLine1URL() {
	return ALT_URL_1;
}

export function getLine2URL() {
	return ALT_URL_2;
}
 